export const REQUESTED = 'ADD_POSTINGS_REQUESTED';
export const FAILED = 'ADD_POSTINGS_FAILED';
export const SUCCESSFUL = 'ADD_POSTINGS_SUCCESSFUL';

export const GET_ALL_POSTING_REQUESTED = 'GET_ALL_POSTING_REQUESTED';
export const GET_ALL_POSTING_FAILED = 'GET_ALL_POSTING_FAILED';
export const GET_ALL_POSTING_SUCCESSFUL = 'GET_ALL_POSTING_SUCCESSFUL';

export const UPDATE_REQUESTED = 'UPDATE_POSTING_REQUESTED';
export const UPDATEG_FAILED = 'UPDATE_POSTING_REQUESTED';
export const UPDATE_SUCCESSFUL = 'UPDATE_POSTING_SUCCESSFUL';

export const DELETE_POSTING_REQUESTED = 'DELETE_POSTING_REQUESTED';
export const DELETE_POSTING_SUCCESSFUL = 'DELETE_POSTING_SUCCESSFUL';
export const DELETE_POSTING_FAILED = 'DELETE_POSTING_FAILED';

export const ALL_POSTINGS_CREATED_SUCCESSFUL = 'ALL_POSTINGS_CREATED_SUCCESSFUL';
export const CREATE_ALL_POSTINGS_FAILED = 'CREATE_ALL_POSTINGS_FAILED';
export const CREATE_POSTINGS_REQUESTED = 'CREATE_POSTINGS_REQUESTED';




// WEBPACK FOOTER //
// ./src/components/Postings/actionTypes.js